import { Spacer } from '@chakra-ui/react';
import EventGridCarousel from 'presentation/components/modules/events/grid/EventGridCarousel';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchEventCategoryDetailQuery } from 'rtkQuery/sharespro/queries/events';

interface Props {
  categoryId: ID;
}

const PassedEventsByCategoryContainer: FC<Props> = ({ categoryId }) => {
  const { t } = useTranslation();

  const { data } = useFetchEventCategoryDetailQuery(categoryId);
  if (data) {
    if (data.prevEvents.length > 0) {
      return <>
        <GridHeading>{t('prevEvents')}</GridHeading>
        <EventGridCarousel events={data.prevEvents} />
        <Spacer h="20px" />
      </>;
    }
  }

  return null;
};

export default PassedEventsByCategoryContainer;
